import { render, staticRenderFns } from "./ladybug.vue?vue&type=template&id=4fe60fb3&scoped=true&"
import script from "./ladybug.vue?vue&type=script&lang=js&"
export * from "./ladybug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe60fb3",
  null
  
)

export default component.exports